import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const OrderQuery = gql`
  query($orderNumber: String!) {
    order(orderNumber: $orderNumber) {
      id
      orderNumber
      createdAt
      grandTotal
      status
      paid
      paidAt

      paymentTotal
      deliveryTotal

      invoiceFirstName
      invoiceLastName
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      anotherDeliveryAddress
      deliveryFirstName
      deliveryLastName
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      language
      
      country {
        id
        code
      }

      currency {
        id
        value
        primary
        exchangeRate
      }

      externalState {
        id
        name
      }
      
      notes

      orderedItems {
        id
        name
        definition
        quantity
        price
        VATrate
        ean
        sku
        image {
          id
          file
        }
      }

      paymentMethod {
        id
        name
        price
        gateway
      }
      deliveryMethod {
        id
        name
        price
        unknownPrice
        unknownPriceLabel
      }
      invoices{
        id
        invoiceNumber
      }

      tariffTotal
    }
  }
`;

interface IInputProps {
  children?: any;
  orderNumber: string;
}

interface IResponse {
  data: any;
}

class GetOrderQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { order }: any = this.props;
    return this.props.children({
      order
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(OrderQuery, {
    name: 'order',
    options: props => ({
      variables: {
        orderNumber: props.orderNumber
      }
    })
  })
)(GetOrderQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Orders/Order.tsx